import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import promise from 'redux-promise';
import { apiActivities } from 'services/activities/api';
import { apiConnectors } from 'services/connectors/api';
import { apiEntities } from 'services/entities/api';
import { apiFeatures } from 'services/features/api';
import { apiEvents } from 'services/events/api';
import { apiItems } from 'services/items/api';
import { apiLogin } from 'services/login/api';
import loginReducer from 'services/login/slice';
import { apiObjectives } from 'services/objectives/api';
import { apiOrganizations } from 'services/organizations/api';
import taskErrorListener from 'services/notices/taskErrors';
import noticesReducer from 'services/notices/slice';
import paneReducer from 'services/pane/slice';
import { apiPayments } from 'services/payments/api';
import { apiProjects } from 'services/projects/api';
import { apiTasks } from 'services/tasks/api';
import { apiTemplates } from 'services/templates/api';
import { apiUsers } from 'services/users/api';

const middlewares = [promise];

const store = configureStore({
  reducer: combineReducers({
    auth: loginReducer,
    notices: noticesReducer,
    pane: paneReducer,
    [apiActivities.reducerPath]: apiActivities.reducer,
    [apiConnectors.reducerPath]: apiConnectors.reducer,
    [apiEntities.reducerPath]: apiEntities.reducer,
    [apiFeatures.reducerPath]: apiFeatures.reducer,
    [apiEvents.reducerPath]: apiEvents.reducer,
    [apiItems.reducerPath]: apiItems.reducer,
    [apiLogin.reducerPath]: apiLogin.reducer,
    [apiObjectives.reducerPath]: apiObjectives.reducer,
    [apiOrganizations.reducerPath]: apiOrganizations.reducer,
    [apiPayments.reducerPath]: apiPayments.reducer,
    [apiProjects.reducerPath]: apiProjects.reducer,
    [apiTasks.reducerPath]: apiTasks.reducer,
    [apiTemplates.reducerPath]: apiTemplates.reducer,
    [apiUsers.reducerPath]: apiUsers.reducer,
  }),
  devTools: process.env.NODE_ENV !== 'production',
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(
        ...middlewares,
        apiActivities.middleware,
        apiConnectors.middleware,
        apiEntities.middleware,
        apiFeatures.middleware,
        apiEvents.middleware,
        apiItems.middleware,
        apiLogin.middleware,
        apiObjectives.middleware,
        apiOrganizations.middleware,
        apiPayments.middleware,
        apiProjects.middleware,
        apiTasks.middleware,
        taskErrorListener,
        apiTemplates.middleware,
        apiUsers.middleware,
      ),
});

setupListeners(store.dispatch);

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
